export const GET_DISTRIBUTOR_CODES = 'GET_DISTRIBUTOR_CODES';
export const GET_DISTRIBUTOR_CODES_SUCCESS = 'GET_DISTRIBUTOR_CODES_SUCCESS';

export const GET_IFSC_DETAILS_SUCCESS = 'GET_IFSC_DETAILS_SUCCESS';
export const GET_IFSC_DETAILS = 'GET_IFSC_DETAILS';

export const GET_DISTRIBUTORS_SUCCESS = 'GET_DISTRIBUTORS_SUCCESS';
export const GET_DISTRIBUTORS = 'GET_DISTRIBUTORS';

export const GET_RMS = 'GET_RMS';
export const GET_RMS_SUCCESS = 'GET_RMS_SUCCESS';

export const GET_Countries_SUCCESS = 'GET_Countries_SUCCESS';
export const GET_Countries = 'GET_Countries';

export const GET_CURRENCY_SUCCESS = 'GET_CURRENCY_SUCCESS';
export const GET_CURRENCY = 'GET_CURRENCY';

export const GET_INVESTMENT_PROFILEMDMS = 'GET_INVESTMENT_PROFILEMDMS';
export const GET_INVESTMENT_PROFILEMDMS_SUCCESS = 'GET_INVESTMENT_PROFILEMDMS_SUCCESS';

export type IfscType = {
  BankAdd1: string;
  BankAdd2: string;
  BankAdd3: string;
  BankCity: string;
  BankName: string;
  BankPin: number;
  IFSCCode: string;
  IFSCOwnedBank: string;
  MicrNo: string;
};
export type mdmsCountriesList = {
  name: string;
  dial_code: string;
  code: string;
  nationality: string;
  panRegex: string;
};
export type nationaliyType = {
  countries: mdmsCountriesList[];
};

export type CurrencyType = {
  key: string;
  value: string;
};
export type CurrencyList = CurrencyType[];

export const GET_DISTRIBUTORS_FOR_FILTERS_SUCCESS = 'GET_DISTRIBUTORS_FOR_FILTERS_SUCCESS';
export const GET_DISTRIBUTORS_FOR_FILTERS = 'GET_DISTRIBUTORS_FOR_FILTERS';

export type keyLabelPair = { key: string; label: string };
export type mdmsInvestorCategoryType = {
  [key: string]: { displayText: string; subCategory: keyLabelPair[] };
};

export const GET_INVESTOR_CATEGORY_SUCCESS = 'GET_INVESTOR_CATEGORY_SUCCESS';
export const GET_INVESTOR_CATEGORY = 'GET_INVESTOR_CATEGORY';

export type mdmsAccridiatedInfoType = { [key: string]: { label: string; info?: string } };

export const GET_ACCRIDIATED_INVESTOR_INFO_SUCCESS = 'GET_ACCRIDIATED_INVESTOR_INFO_SUCCESS';
export const GET_ACCRIDIATED_INVESTOR_INFO = 'GET_ACCRIDIATED_INVESTOR_INFO';
